import { render, staticRenderFns } from "./NavVerticalLab.vue?vue&type=template&id=e11a2a88&scoped=true"
import script from "./NavVerticalLab.vue?vue&type=script&lang=js"
export * from "./NavVerticalLab.vue?vue&type=script&lang=js"
import style0 from "./NavVerticalLab.vue?vue&type=style&index=0&id=e11a2a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11a2a88",
  null
  
)

export default component.exports